import styled, { css } from 'styled-components'

export const ErrorBox = styled.div`
  margin: 0 auto;
  max-width: 800px;
  padding: 32px;
  display: flex;
  justify-content: space-between;

  img {
    width: 280px;
  }

  .error-info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: center;

    h1 {
      font-weight: 500;
      font-size: 120px;
      margin: 0;
    }

    strong {
      font-weight: 600;
      font-size: 20px;
      margin-top: -32px;
    }

    p {
      font-weight: 400;
      font-size: 16px;
      margin-bottom: 12px;
    }

    button {
    }
  }

  @media (max-width: 800px) {
    justify-content: center;
    img {
      display: none;
    }
  }
`

export const Button = styled.button`
  ${({ theme }) => css`
    border-radius: 4px;
    border: 2px solid transparent;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
    padding: 10px 30px;
    text-align: center;
    transition: ${theme.transition.default};
    cursor: pointer;
    background: ${theme.colors.primary};
    color: ${theme.colors.white};

    &:hover {
      background: #a71e26;
    }

    & + .button {
      margin-left: 15px;
    }

    @media (max-width: ${theme.media.ipad}) {
      font-size: 14px;
    }
  `}
`
